document.addEventListener("DOMContentLoaded", () => {
  // Get autoplay settings from data attributes
  const swiperContainer = document.querySelector(
    ".testimonials-single__swiper"
  );
  const enableAutoplay =
    swiperContainer?.dataset.enableAutoplay === "true" || false;
  const autoplayDelay = parseInt(swiperContainer?.dataset.autoplayDelay) || 5;

  const swiperConfig = {
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,
    allowTouchMove: true, // Enable touch/swipe for mobile
    navigation: {
      nextEl: ".testimonials-single__nav-btn--next",
      prevEl: ".testimonials-single__nav-btn--prev",
    },
    speed: 800,
  };

  // Only add autoplay if enabled
  if (enableAutoplay) {
    swiperConfig.autoplay = {
      delay: autoplayDelay * 1000, // Convert seconds to milliseconds
      disableOnInteraction: false,
    };
  } else {
    // Explicitly disable autoplay when not enabled
    swiperConfig.autoplay = false;
  }

  const swiper = new Swiper(".testimonials-single__swiper", swiperConfig);

  // Ensure autoplay is completely disabled if not enabled
  if (!enableAutoplay) {
    if (swiper.autoplay && swiper.autoplay.stop) {
      swiper.autoplay.stop();
    }
    // Disable autoplay completely
    swiper.autoplay = false;
  }

  // Add keyboard navigation
  document.addEventListener("keydown", (e) => {
    if (e.key === "ArrowLeft") {
      swiper.slidePrev();
    } else if (e.key === "ArrowRight") {
      swiper.slideNext();
    }
  });

  // Pause autoplay on hover (only if autoplay is enabled)
  if (enableAutoplay) {
    const swiperElement = document.querySelector(
      ".testimonials-single__swiper"
    );
    if (swiperElement) {
      swiperElement.addEventListener("mouseenter", () => {
        swiper.autoplay.stop();
      });

      swiperElement.addEventListener("mouseleave", () => {
        swiper.autoplay.start();
      });
    }
  }

  // Add accessibility improvements (only if autoplay is enabled)
  if (enableAutoplay) {
    const navButtons = document.querySelectorAll(
      ".testimonials-single__nav-btn"
    );
    navButtons.forEach((button, index) => {
      button.addEventListener("focus", () => {
        // Pause autoplay when navigation is focused
        if (swiper.autoplay && swiper.autoplay.stop) {
          swiper.autoplay.stop();
        }
      });

      button.addEventListener("blur", () => {
        // Resume autoplay when navigation loses focus
        if (swiper.autoplay && swiper.autoplay.start) {
          swiper.autoplay.start();
        }
      });
    });
  }

  // Update navigation button states based on current slide
  swiper.on("slideChange", () => {
    const prevBtn = document.querySelector(
      ".testimonials-single__nav-btn--prev"
    );
    const nextBtn = document.querySelector(
      ".testimonials-single__nav-btn--next"
    );

    if (prevBtn && nextBtn) {
      // Add visual feedback for current slide
      const currentSlide = swiper.realIndex;
      const totalSlides = swiper.slides.length;

      // Update aria-labels with current position
      prevBtn.setAttribute(
        "aria-label",
        `Previous testimonial (${
          currentSlide === 0 ? totalSlides : currentSlide
        } of ${totalSlides})`
      );
      nextBtn.setAttribute(
        "aria-label",
        `Next testimonial (${
          currentSlide === totalSlides - 1 ? 1 : currentSlide + 2
        } of ${totalSlides})`
      );
    }
  });

  // Initialize first slide
  swiper.on("init", () => {
    const nextBtn = document.querySelector(
      ".testimonials-single__nav-btn--next"
    );
    if (nextBtn) {
      nextBtn.setAttribute("aria-label", "Next testimonial (2 of 1)");
    }
  });

  // Prevent autoplay from being enabled on resize
  window.addEventListener("resize", () => {
    if (!enableAutoplay && swiper.autoplay) {
      swiper.autoplay.stop();
      swiper.autoplay = false;
    }
  });
});
